import React, { Component, Fragment } from 'react';
import { Filter, Main } from 'Containers/';
import { connect } from 'react-redux';

import moment from 'moment';
import { withRouter } from 'react-router';
import { VerificationResultsLettersForm } from './components/VerificationResultsLettersForm';
import { VerificationResultsLettersFieldEnum as Fields } from 'Common/FieldEnum';
import { VERIFICATION_RESULTS_LETTERS_FORM_NAME } from 'Common/FormEnum';
import * as useStudentAddressSelectors from 'Common/Components/UseStudentAddressButtonGroup/Selectors';
import {
  getResultsCounts,
  getResultsLetters,
  clearReport,
  writeSuccess,
} from './state/report/actions';
import { toastType, createToast } from 'Common/ToastHelper';
import { ReportGeneration } from 'Common/ObjectHelper';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { LoadingPage, YesNoDialog } from 'Components/';

class ResultsLettersContainer extends Component {
  state = {
    showYNDialog: false,
    loadingMessage: null,
  };

  componentDidMount() {
    this.props.getResultsCounts();
  }

  componentDidUpdate(prevProps, prevState) {
    const { report, error } = this.props;

    if (error) {
      createToast(toastType.error, 'Error', 'Error retrieving report!', true);
    } else {
      if (prevProps.report !== report && report) {
        if (report === 'No Data') {
          createToast(toastType.info, 'Results', 'No data found!', true);
        } else {
          ReportGeneration(report, 'Results Letters');
          this.setState({ showYNDialog: true });
        }
      }
    }
    this.props.clearReport();
  }

  getMainProps = () => {
    const { loading } = this.props;

    return {
      toolbox: {
        formName: VERIFICATION_RESULTS_LETTERS_FORM_NAME,
        saveButtonProps: {
          content: 'View',
        },
        shown: true,
        loading: loading,
      },
    };
  };

  onYesPrinted = () => {
    this.props.writeSuccess(this.props.selectedHouseholds);
    this.setState({ showYNDialog: false });
  };

  handleSubmit = formValues => {
    this.setState({ loadingMessage: 'Loading Letters' });
    this.props.getResultsLetters(formValues);
  };

  render() {
    const { showYNDialog, loadingMessage } = this.state;
    const { loading, useStudentAddress } = this.props;

    return (
      <Fragment>
        {loading ? (
          <LoadingPage message={loadingMessage ? loadingMessage : 'Loading'} />
        ) : (
          undefined
        )}

        <Filter title={'Results Letters'} />
        <Main {...this.getMainProps()}>
          <VerificationResultsLettersForm
            onSubmit={this.handleSubmit}
            initialValues={{
              [Fields.PrintType]: 0,
              [Fields.LetterDate]: defaultDateFormat(moment()),
              [Fields.HearingDate]: defaultDateFormat(moment()),
              [Fields.UseStudentAddress]: useStudentAddress,
              [Fields.ShowSiteName]: false,
            }}
          />
        </Main>
        <YesNoDialog
          showDialog={showYNDialog}
          title={'Was printing successful?'}
          question={<span>Did the letters print successfully?</span>}
          yesCallback={this.onYesPrinted}
          noCallback={() => {
            this.setState({ showYNDialog: false });
          }}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { report } = state.ResultsLettersState;

  return {
    report: report.report,
    loading: report.loading,
    error: report.error,
    resultsCounts: report.resultsCounts,
    selectedHouseholds: report.selectedHouseholds,
    useStudentAddress: useStudentAddressSelectors.getUseStudentAddressSetting(
      state,
      VERIFICATION_RESULTS_LETTERS_FORM_NAME,
      false
    ),
  };
};

export const ResultsLetters = withRouter(
  connect(mapStateToProps, {
    getResultsCounts,
    getResultsLetters,
    clearReport,
    writeSuccess,
  })(ResultsLettersContainer)
);



// WEBPACK FOOTER //
// ./src/pages/resultsletters/ResultsLetters.js